module.exports = __webpack_public_path__ + "static/img/wallet.003accd5.png";